import { useState } from "react";
import Layout from "../components/Layout";

export default function Subscriptions() {
  const [subscriptions, setSubscriptions] = useState([
    { id: 1, name: "Silver", price: 10, features: "Basic access, View records" },
    { id: 2, name: "Gold", price: 25, features: "All Silver features + Upload & Download, Priority support" }
  ]);

  const [form, setForm] = useState({ name: "", price: "", features: "" });

  const handleAdd = () => {
    if (!form.name || !form.price) return alert("Name and price are required.");
    setSubscriptions(prev => [
      ...prev,
      { id: Date.now(), ...form }
    ]);
    setForm({ name: "", price: "", features: "" });
  };

  const handleDelete = (id) => {
    if (window.confirm("Delete this subscription plan?")) {
      setSubscriptions(prev => prev.filter(s => s.id !== id));
    }
  };

  return (
    <Layout>
      <div className="p-6 space-y-6">
        <h1 className="text-2xl font-bold">Manage Subscriptions</h1>

        {/* Add Subscription Form */}
        <div className="bg-white p-4 rounded shadow space-y-4">
          <h2 className="text-lg font-semibold">Add New Subscription</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <input
              type="text"
              placeholder="Plan Name (e.g. Gold)"
              value={form.name}
              onChange={e => setForm({ ...form, name: e.target.value })}
              className="border p-2 rounded"
            />
            <input
              type="number"
              placeholder="Price (USD)"
              value={form.price}
              onChange={e => setForm({ ...form, price: e.target.value })}
              className="border p-2 rounded"
            />
            <input
              type="text"
              placeholder="Features (comma separated)"
              value={form.features}
              onChange={e => setForm({ ...form, features: e.target.value })}
              className="border p-2 rounded"
            />
          </div>
          <button
            onClick={handleAdd}
            className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
          >
            Add Subscription
          </button>
        </div>

        {/* Table View */}
        <div className="bg-white p-4 rounded shadow">
          <h2 className="text-lg font-semibold mb-4">Available Plans</h2>
          <table className="w-full text-sm border">
            <thead className="bg-gray-100 text-left">
              <tr>
                <th className="p-2">Name</th>
                <th className="p-2">Price</th>
                <th className="p-2">Features</th>
                <th className="p-2 text-right">Actions</th>
              </tr>
            </thead>
            <tbody>
              {subscriptions.map(plan => (
                <tr key={plan.id} className="border-t">
                  <td className="p-2">{plan.name}</td>
                  <td className="p-2">${plan.price}</td>
                  <td className="p-2">{plan.features}</td>
                  <td className="p-2 text-right">
                    {/* Future: Add Edit */}
                    <button
                      onClick={() => handleDelete(plan.id)}
                      className="text-red-600 hover:underline text-sm"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
              {subscriptions.length === 0 && (
                <tr><td className="p-2 italic text-gray-500" colSpan="4">No plans found.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </Layout>
  );
}
